import React from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { toast } from "react-toastify";
import { useParams, Link } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import UsedInBadge from "../UsedInBadge";
import HelpButton from "../../../HelpContent/HelpButton";
import {
  deleteMessageConfig,
  selectMessageConfigs,
  selectProjectMessageConfigUUID,
} from "../../../store/slices/projectSlice";
import { faMinus, faPlus } from "@fortawesome/free-solid-svg-icons";

export default function MessageConfigsList() {
  const params = useParams();
  const projectMessageConfigUUID = useSelector(selectProjectMessageConfigUUID);
  const messageConfigs = useSelector(selectMessageConfigs);
  const dispatch = useDispatch();

  return (
    <div className="mt-2 card">
      <div className="card-header m-0 p-2 d-flex align-items-start">
        <h5 className="card-title">Message configs</h5>
        <HelpButton helpKey="components-message-configs" />
        <div className="flex-grow-1" />
        <Link
          to={`/library/logic/builder/${params.projectID}/message-config/create_new`}
          className="btn btn-outline-primary btn-sm border-0"
        >
          <FontAwesomeIcon icon={faPlus} />
        </Link>
      </div>
      <div className="card-body p-0">
        {messageConfigs.length > 0 ? (
          <ul className="list-group list-group-flush">
            {messageConfigs.map((messageConfig) => (
              <li
                key={messageConfig.UUID}
                className="list-group-item p-2 d-flex align-items-center"
              >
                <Link
                  to={`/library/logic/builder/${params.projectID}/message-config/${messageConfig.UUID}`}
                >
                  <span title={messageConfig.UUID}>
                    {messageConfig.Label.slice(0, 20) ||
                      messageConfig.UUID.slice(0, 5)}{" "}
                  </span>
                </Link>

                <span className="flex-grow-1" />
                {
                  // is it the default
                  projectMessageConfigUUID === messageConfig.UUID && (
                    <span
                      className="badge bg-success me-2"
                      title="Project default"
                    >
                      default
                    </span>
                  )
                }

                {
                  // number of places used in

                  <UsedInBadge
                    arg={messageConfig}
                    alt={
                      // delete button
                      projectMessageConfigUUID !== messageConfig.UUID && (
                        // eslint-disable-next-line jsx-a11y/control-has-associated-label
                        <button
                          type="button"
                          className="btn btn-outline-danger btn-sm border-0"
                          onClick={() => {
                            dispatch(deleteMessageConfig(messageConfig.UUID));
                            toast.success("Message config deleted");
                          }}
                          title="Delete message config"
                        >
                          <FontAwesomeIcon icon={faMinus} />
                        </button>
                      )
                    }
                  />
                }
              </li>
            ))}
          </ul>
        ) : (
          <div className="text-center m-1">No message configs</div>
        )}
      </div>
    </div>
  );
}
